import { Authorization } from 'components/Permissions';
// Rosters
export const CanViewRosters = Authorization(['can_view_rosters', 'can_admin_rosters']);
export const CanViewDraftRosters = Authorization(['can_view_drafts', 'can_admin_rosters']);
export const CanAdminRosters = Authorization(['can_admin_rosters']);
// Activities
export const CanViewActivities = Authorization(['can_view_activities', 'can_admin_activities']);
export const CanAdminActivities = Authorization(['can_admin_activities']);
// Competencies
export const CanViewCompetencies = Authorization(['can_view_competencies', 'can_admin_competencies']);
export const CanAdminCompetencies = Authorization(['can_admin_competencies']);
// Travel
export const CanViewTravel = Authorization(['can_view_travel', 'can_admin_travel']);
export const CanAdminTravel = Authorization(['can_admin_travel']);
// Tags
export const CanViewTags = Authorization(['can_view_tags', 'can_admin_tags']);
export const CanAdminTags = Authorization(['can_admin_tags']);
// Availability
export const CanViewAvailability = Authorization(['can_view_availability', 'can_admin_availability']);
export const CanAdminAvailability = Authorization(['can_admin_availability']);
// Reporting
export const CanAdminReports = Authorization(['can_admin_reports']);
export const CanViewReports = Authorization(['can_view_reports', 'can_admin_reports']);
// Users
export const CanViewUsers = Authorization(['can_view_users', 'can_admin_users']);
export const CanAdminUsers = Authorization(['can_admin_users']);
// Optimiser
export const CanViewOptimiser = Authorization(['can_view_optimiser', 'can_admin_optimiser']);
export const CanAdminOptimiser = Authorization(['can_admin_optimiser']);
// Permissions
export const CanAdminPermissions = Authorization(['can_admin_permissions']);
export const CanViewPermissions = Authorization(['can_view_permissions', 'can_admin_permissions']);

export const CanAdminICal = Authorization(['can_admin_users', 'basic_access']);
// profile

// @deprecated - we can remove this until such time as the profile editing is required
export const CanAdminProfile = Authorization(['can_admin_own_profile']);

// Availabilities
export const CanViewAvailabilities = Authorization(['can_view_availability', 'can_admin_availability']);
export const CanAdminAvailabilities = Authorization(['can_admin_availability']);
// Actions
export const CanViewActions = Authorization(['basic_access', 'can_view_actions', 'can_admin_actions']);
export const CanAdminActions = Authorization(['can_admin_actions']);

export const BasicAccess = Authorization(['basic_access']);

export const CanAdminComments = Authorization(['can_admin_comments']);
export const CanViewComments = Authorization(['can_admin_comments', 'can_view_comments']);
